import React, { useContext } from 'react';
import { LoginContext } from 'src/lib/LoginContext';
import { GlobalBanner } from './GlobalBanner';

export const YouHaveBeenLoggedOut = () => {
  const { youHaveBeenLoggedOut, clearYouHaveBeenLoggedOut } = useContext(LoginContext);

  if(!youHaveBeenLoggedOut) return null;

  return (
    <GlobalBanner
      color='error'
      onDismiss={() => clearYouHaveBeenLoggedOut()}
    >
      You have been logged out
    </GlobalBanner>
  );
};
